<template>
    <div class="mercado-clone-wrap">
        <div class="mercado-panels-actions-wrap">
            <!-- <a class="mercado-close-btn mercado-close-panels home" v-bind:href="this.$SiteUrl + 'loja'"><i class="fa fa-home"></i></a> -->

            <a class="mercado-close-btn mercado-close-panels" href="#">x</a>
        </div>
        <div class="mercado-panels"></div>
    </div>
</template>

<script>
export default {
    name: 'MobileMenu'
}
</script>
